//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { createSEOMeta } from '~/services/seo';
import { ARTICLE_TYPE } from '~/static/constants';
import { getFullUrl, truncateHtml } from '~/services/utilityFunctions.js';
import { BLOG_META_INFO } from '~/constants/blogConstants';

const ArticleDesktop = () => import('~/components/Articles/DeskComponents/ArticleDesktop.vue');
const ArticleMobile = () => import('~/components/Articles/PWAComponents/ArticleMobile.vue');
const InstructionsModal = () => import('~/components/Home/InstructionsModal.vue');

export default {
    name: 'ArticleSlug',
    components: { ArticleMobile, ArticleDesktop, InstructionsModal },
    inject: ['blogTopic'],
    props: {
        articleMetadata: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            imageLoaderRanCounter: 5,
            isArticleTruncated: false, // Show blog as preview with continue reading button
            articleContent: '',
            metaTitle: BLOG_META_INFO[this.blogTopic].title,
            metaDescription: BLOG_META_INFO[this.blogTopic].description
        };
    },
    head() {
        return {
            script: this.getSchemaStructure(),
            link: [{ rel: 'canonical', href: getFullUrl(this.$route.path) }],
            title: this.articleMetadata ? this.articleMetadata.metaTitle : this.metaTitle,
            meta: [
                ...createSEOMeta({
                    title: this.articleMetadata ? this.articleMetadata.metaTitle : this.metaTitle,
                    description: this.articleMetadata
                        ? this.articleMetadata.metaDescription
                        : this.metaDescription,
                    url: this.$route.fullPath
                })
            ]
        };
    },
    computed: {
        ...mapGetters({
            showInstructions: 'testSets/showInstructions'
        })
    },
    // watch: {
    //     articleMetadata(val) {
    //         if (val) {
    //             this.setArticleContent({ truncate: false });
    //         }
    //     }
    // },
    mounted() {
        // ** COMMENTING THE setArticle() call to improve LCS, directly passing the article content now **
        // Set truncate value as per the desired initial state of blog article
        // this.setArticleContent({ truncate: false });
        this.loadDeferredImages();
    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.replaceImageSrc);
    },
    methods: {
        // ** NOT USED CURRENTLY **
        setArticleContent({ truncate = true }) {
            if (!this.articleMetadata) return;

            // CASE 1 - GUIDE - Show full content since start
            if (this.articleMetadata.type === ARTICLE_TYPE.GUIDE || truncate === false) {
                this.articleContent = this.articleMetadata.articleContent;
                this.isArticleTruncated = false;
                this.loadDeferredImages();
                return;
            }

            // CASE 2 - BLOGS - Show truncated content at start
            const TRUNCATED_CONTENT_LIMIT = this.$device.isMobile ? 400 : 900;
            if (this.articleMetadata.articleContent.length > TRUNCATED_CONTENT_LIMIT) {
                this.articleContent = truncateHtml(
                    this.articleMetadata.articleContent,
                    TRUNCATED_CONTENT_LIMIT
                );

                this.isArticleTruncated = true;
            }
        },
        getSchemaStructure() {
            const headerScript = [];
            headerScript.push({
                type: 'application/ld+json',
                json: this.articleMetadata?.faqSchemaStructure || {}
            });
            headerScript.push({
                type: 'application/ld+json',
                json: this.articleMetadata?.articleSchemaStructure || {}
            });

            return headerScript;
        },
        loadDeferredImages() {
            this.imageLoaderRanCounter = 5;
            document.addEventListener('scroll', this.replaceImageSrc);

            // The hero image has already src and others have data-src
            // The others will replace to src on scroll

            // setTimeout(() => this.replaceImageSrc(), 200);
        },
        replaceImageSrc() {
            if (this.imageLoaderRanCounter > 0) {
                try {
                    const imgDefer = document.getElementsByTagName('img');
                    const vidDefer = document.getElementsByTagName('iframe');

                    for (let item = 0; item < imgDefer.length; item++) {
                        // eslint-disable-next-line max-depth
                        if (imgDefer[item].getAttribute('data-src')) {
                            imgDefer[item].setAttribute(
                                'src',
                                imgDefer[item].getAttribute('data-src')
                            );
                            imgDefer[item].removeAttribute('data-src');
                        }
                    }

                    for (let item = 0; item < vidDefer.length; item++) {
                        // eslint-disable-next-line max-depth
                        if (vidDefer[item].getAttribute('data-src')) {
                            vidDefer[item].setAttribute(
                                'src',
                                vidDefer[item].getAttribute('data-src')
                            );
                            vidDefer[item].removeAttribute('data-src');
                        }
                    }
                } catch (err) {
                    document.removeEventListener('scroll', this.replaceImageSrc);
                }

                this.imageLoaderRanCounter--;
            }
        }
    }
};
